//Function to convert larger texts to smaller ones
const reviewsText = document.querySelectorAll('.container-review .review');

reviewsText.forEach((review) => {
    let buttonExpandText = document.createElement('button');
    buttonExpandText.classList.add('review__button');
    buttonExpandText.textContent = 'Read more';

    if (review.offsetHeight > 280) {
        review.classList.add('review--small');
        review.after(buttonExpandText);
    }
    function expandText() {
        review.classList.toggle('review--small');
        if (review.classList.contains('review--small')) {
            buttonExpandText.textContent = 'Read more';
        } else {
            buttonExpandText.textContent = 'Read less';
        }
    }
    buttonExpandText.addEventListener('click', expandText);
});
